import { Show } from './Show';
import Create from './Create';
import Edit from './Edit';
import { ClientList as List } from './ClientList';
import { clientsColumns } from './ClientList.model';

export { Show, Create, Edit, clientsColumns, List };
export default { Show, Create, Edit, clientsColumns, List };
